import React, { FunctionComponent } from 'react';

import { TextButton } from '@components/library/button';

import classes from './styles/press_release_toggle_all.module.scss';

interface PressReleaseToggleAllProps {
  handleDeselectAll: (deselectAll?: boolean) => void;
  handleSelectAll: (selectAll?: boolean) => void;
  heading: string;
  deselectAllText?: string;
  disableDeselectAll?: boolean;
  disableSelectAll?: boolean;
  selectAllText?: string;
  showToggles?: boolean;
}

export const PressReleaseToggleAll: FunctionComponent<PressReleaseToggleAllProps> = (props) => {
  const {
    deselectAllText,
    disableDeselectAll,
    disableSelectAll,
    handleDeselectAll,
    handleSelectAll,
    heading,
    selectAllText,
    showToggles = true
  } = props;

  return (
    <div className={classes.toggleAll}>
      <h4 className={classes.h4}>{heading}</h4>
      {showToggles && (
        <>
          <TextButton
            disabled={disableSelectAll}
            onClick={(): void => handleSelectAll(true)}
          >
            {selectAllText || bfTranslate('Select All')}
          </TextButton>
          <span aria-hidden className={classes.pipe}>|</span>
          <TextButton
            disabled={disableDeselectAll}
            onClick={(): void => handleDeselectAll(false)}
          >
            {deselectAllText || bfTranslate('Deselect All')}
          </TextButton>
        </>
      )}
    </div>
  );
};
